import React from "react";

import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SharedModal.css";

const ErrorModal = ({ show, message, handleClose }) => {

    return (
        <Modal
            size="lg"
            centered
            show={show}
            onHide={handleClose}
            className="custom-modal"
        >
            <Modal.Header closeButton>
                <h2 className="modal-heading" style={{ color: 'var(--error)' }}>Error</h2>
            </Modal.Header>
            <Modal.Body>
                <div className="modal-form-group">
                    <div className="modal-info-box" style={{ 
                        background: 'var(--error-light)', 
                        borderColor: 'var(--error)',
                        borderLeft: '4px solid var(--error)'
                    }}>
                        <p className="modal-text" style={{ 
                            color: 'var(--error)', 
                            margin: 0,
                            fontWeight: '500'
                        }}>
                            {message}
                        </p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="modal-btn primary" onClick={handleClose}>
                    OK
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default ErrorModal;